export default "__VITE_ASSET__BPPScNB1__"